import { useAdminApi } from '@hooks/useAdminApi';
import { KillSwitch } from '@protos/trading';
import { useRef, useState, useEffect } from 'react';

export const useTradingKillSwitch = (killSwitchType: 'otc' | 'hedger') => {
  const { apiClient } = useAdminApi();
  const [killSwitch, setKillSwitch] = useState<KillSwitch | null>(null);

  const onToggleKillSwitch = async (event: React.ChangeEvent<HTMLInputElement>, newCheckedValue: boolean) => {
    if (!killSwitch) {
      throw new Error('Cannot set kill switch before current value is retrieved from server');
    }

    const newKillSwitch = await apiClient?.setKillSwitch(newCheckedValue, killSwitch?.active_limit_orders || false, killSwitchType);
    if (!newKillSwitch) return;

    setKillSwitch(newKillSwitch);
  };

  const onToggleLimitKillSwitch = async (event: React.ChangeEvent<HTMLInputElement>, newCheckedValue: boolean) => {
    if (!killSwitch) {
      throw new Error('Cannot set kill switch before current value is retrieved from server');
    }

    const newKillSwitch = await apiClient?.setKillSwitch(killSwitch?.active || false, newCheckedValue, killSwitchType);
    if (!newKillSwitch) return;

    setKillSwitch(newKillSwitch);
  };

  const killSwitchPollingFnRef = useRef<(() => void) | null>(null);
  const killSwitchPollingIntervalRef = useRef<number | null>(null);

  useEffect(() => {
    if (!apiClient) {
      return;
    }

    killSwitchPollingFnRef.current = async () => {
      const killSwitch = await apiClient.getKillSwitch(killSwitchType);
      setKillSwitch(killSwitch);
    };

    killSwitchPollingIntervalRef.current = window.setInterval(killSwitchPollingFnRef.current!, 500);
    killSwitchPollingFnRef.current!();

    return () => {
      if (killSwitchPollingIntervalRef.current) {
        window.clearInterval(killSwitchPollingIntervalRef.current);
      }
    };
  }, [apiClient]);

  return { killSwitch, onToggleKillSwitch, onToggleLimitKillSwitch };
};
